export default {
  JOIN_URL: '/teams-creation/join/',
  ES_JOIN_URL: '/create-page',
  TEAMS_CREATION: '/teams-creation/',
  TEAMS: '/team/',
  FRP: '/fundraising/',
  FRP_CREATION: '/fundraising-page/creation',
};
